export default __webpack_public_path__ + "static/media/file-upload.147362c7.svg";